import React, {useCallback, useEffect, useState} from "react";
import styles from "./PatientInfo.module.scss";
import {MaleIcon, SaveIcon} from "../../assets";
import InputMask from "react-input-mask";
import {Autocomplete, Input, Switcher} from "../../ui-components";
import TimePicker from "react-time-picker";
import moment from "moment";
import { CUSTOMERSREGIONS} from "../../services/constants";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {omit} from "lodash";
import {updateCustomerInfoRequests} from "../requests/er-thunk";
import {Datepicker, Spinner} from "../../shared";

const PatientInfo = ({isEditable}) => {
  const dispatch = useAppDispatch()

  const {
    request,
    pool,
    activePanel,
    er_call,
    insurance_org,
    emergency_responsible
  } = useAppSelector(state => state.requests)
  const [loader, setLoader] = useState(false)

  const [updateData, setUpdateData] = useState({
    birthday: moment(request?.birthday).toString(),
    scheduled_date: moment(request?.scheduled_date).toString(),
    patient_name: request?.patient_name || request?.name,
    contact_number: request.contact_number,
    // complaints: request.complaints,
    // notes: request.notes,
    address: request?.address,
    time: request?.time,
    data: {
      floor: request?.data?.floor,
      appartment: request?.data?.appartment,
      elevator: request?.data?.elevator,
      freight: request?.data?.freight,
    }
  })

  useEffect(() => {
    setUpdateData({
      birthday: moment(request?.birthday).toString(),
      scheduled_date: moment(request?.scheduled_date).toString(),
      patient_name: request?.patient_name || request?.name,
      contact_number: request.contact_number,
      // complaints: request.complaints,
      // notes: request.notes,
      address: request?.address,
      time: request?.time,
      data: {
        floor: request?.data?.floor,
        appartment: request?.data?.appartment,
        elevator: request?.data?.elevator,
        freight: request?.data?.freight,
      }
    })
  }, [request])
  const isValid = (data) => {
    const dataWithoutFoodAndWC = { ...data };
    return Object.keys(dataWithoutFoodAndWC).every((k) => {
      return data[k]
    })
  }
  const handleUpdate = useCallback( () => {
    if (isValid(omit(updateData, ['comment1']))) {
      setLoader(true);
      dispatch(updateCustomerInfoRequests({uuid: request?.uuid, data:updateData})).then(res => {
        // @ts-ignore
        if(res) {
          setTimeout(() => {
            setLoader(false);
            // setAcceptSuccess(true);
          }, 1000); // Delay of 100ms
        }
      })
    } else {
      // setErrorMessage('*Заполните все поля.')
    }
  }, [dispatch, request?.uuid, updateData])

  return <div className={styles.container}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <MaleIcon  className='mr-5'/>
        <p className={styles.title}>Данные пациента</p>
        <div className={styles.title} >{request?.sentry_type}</div>
        {!isEditable && (
          loader ? (
            <Spinner/>
          ) : (
            <SaveIcon style={{ cursor: "pointer" }} onClick={handleUpdate} />
          )
        )}
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.bodyHeadWrapper} >
        <div style={{width: "40%"}}>
        <Datepicker error={!updateData.birthday}
                    // disableDates={new Date().toString()}
                    inputDisabled={isEditable}
                    disableDates={"future"}
                    handleDateChange={(date) => setUpdateData({...updateData, birthday: date})}
                    value={updateData.birthday || new Date().toString()} label={"Дата Рождения"}/>
        </div>
        <Input name='name'
               onChange={(e) => setUpdateData({...updateData, patient_name: e?.target?.value})}
               value={updateData.patient_name}
               error={!updateData.patient_name}
               className={styles.input}
               disabled={isEditable}
               label="Имя"/>
      </div>

      <div className={styles.bodyHeadWrapper} >
        <div style={{width: "44%"}}>
        <Datepicker error={!updateData.scheduled_date}
                    disableDates={new Date().toString()}
                    inputDisabled={isEditable}
                    handleDateChange={(date) => setUpdateData({...updateData, scheduled_date: date})}
                    value={updateData.scheduled_date || new Date().toString()} label={"Дата вызова"}/>
        </div>
        <div style={{width: "100%",  paddingBottom: 4, borderBottom: '1px #BDC1CC solid', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex'}}>
          <div style={{    position: "relative",
            marginTop: -20, alignSelf: 'stretch', color: '#505D66', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Время прибытия</div>
          <TimePicker disabled={isEditable}  className={[styles.timePicker]} required clearIcon secondPlaceholder={"Time"} format={"H:mm"} disableClock  onChange={(e) => setUpdateData({...updateData, time: e})} value={updateData?.time} />
        </div>
      </div>

      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Autocomplete className={styles.select}
                      options={CUSTOMERSREGIONS}
                      optionLabel={'type'}
                      optionValue={'key'}
                      value={request.city === "Москва" ? 1 : 2}
                      disabled
                      label="Город"/>
        <InputMask mask="+7 (999) 999-99-99" maskChar=" "
                   className={styles.input}
                   name='contact_number'
                   value={request.contact_number}
                   disabled
                   onChange={() => {}}
                   label={"Номер телефона"}>
          {(inputProps) => <Input disabled {...inputProps} />}
        </InputMask>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='inn'
               className={styles.input}
               value={updateData?.address}
               error={!updateData?.address}
               disabled={isEditable}
               onChange={(e) => setUpdateData({...updateData, address: e?.target?.value})}
               label="Адрес"/>
      </div>

      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='inn'
               className={styles.input}
               value={updateData?.data?.floor}
               disabled={isEditable}
               onChange={(e) => setUpdateData({...updateData, data: {...updateData?.data, floor: e?.target?.value}})}
               label="Этаж"/>
        <Input name='inn'
               className={styles.input}
               value={updateData?.data?.appartment}
               disabled={isEditable}
               onChange={(e) => setUpdateData({...updateData, data: {...updateData?.data, appartment: e?.target?.value}})}
               label="Квартира"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Switcher  disabled={isEditable} defaultChecked={updateData?.data?.elevator} id={"uniq"}  onChange={(event) => setUpdateData({...updateData,  data: {...updateData?.data, elevator: !updateData?.data?.elevator}})} label="Наличие лифта" name="elevator"  />
        <Switcher  disabled={isEditable} defaultChecked={updateData?.data?.freight} id={"uniq"}  onChange={(event) => setUpdateData({...updateData, data: {...updateData?.data, freight: !updateData?.data?.freight}})} label="Грузовой лифт" name="freight"  />
      </div>
    </div>
  </div>
}

export default PatientInfo
